import { render, staticRenderFns } from "./ResizablePanel.vue?vue&type=template&id=2f044bca&scoped=true"
import script from "./ResizablePanel.vue?vue&type=script&lang=js"
export * from "./ResizablePanel.vue?vue&type=script&lang=js"
import style0 from "./ResizablePanel.vue?vue&type=style&index=0&id=2f044bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f044bca",
  null
  
)

export default component.exports